import React from "react";
import FruitRipenessChecker from "./RipenessCheck";

const Scan = () => {
  return (
    <div>
      <div className="px-4">
        <FruitRipenessChecker />
      </div>
    </div>
  );
};

export default Scan;
